import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MagneticCursor from "@/components/MagneticCursor";
import NoiseOverlay from "@/components/NoiseOverlay";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import SolutionsPage from "@/pages/SolutionsPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPages from "@/pages/admin/AdminPages";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminLayout from "@/components/AdminLayout";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="min-h-screen">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <MagneticCursor />
      <NoiseOverlay />
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/solutions" element={<PublicLayout><SolutionsPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/admin/pages" element={<AdminLayout><AdminPages /></AdminLayout>} />
        <Route path="/admin/blogs" element={<AdminLayout><AdminBlogs /></AdminLayout>} />
        <Route path="/admin/blogs/new" element={<AdminLayout><AdminBlogEditor /></AdminLayout>} />
        <Route path="/admin/blogs/:id" element={<AdminLayout><AdminBlogEditor /></AdminLayout>} />
        <Route path="/admin/contacts" element={<AdminLayout><AdminContacts /></AdminLayout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
